import React from "react";

/** Driver name and phone from a TrackHub webhook, with the carrier company underneath. */
export default function CourierInfoCell({ row }) {
  const name = row?.courierName;
  const phone = row?.courierPhone;
  if (!name && !phone) {
    return row?.carrier || "—";
  }
  return (
    <div className="trackhub-reports-courier">
      {name ? <span className="trackhub-reports-courier__name">{name}</span> : null}
      {phone ? (
        <span className="trackhub-reports-courier__phone" dir="ltr">
          {phone}
        </span>
      ) : null}
      {row?.carrier ? (
        <span className="trackhub-reports-courier__carrier">{row.carrier}</span>
      ) : null}
    </div>
  );
}
